import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IUserLookupService } from "../IUserLookupService";
import { LoggerService } from "@bfx/logger";
import { NullProtoObject } from "../../../../helper-services/null-proto-object";
const logger = LoggerService.for(__dirname);

@Injectable()
export class UserLookupService
  extends BaseLookupService<string, CubiqTS.UserImpl>
  implements IUserLookupService
{
  private userCodeMap: NullProtoObject<CubiqTS.UserImpl> = Object.create(null);
  private usersByClientCodeMap: NullProtoObject<CubiqTS.UserImpl[]> = Object.create(null);
  private privatizationItemMap: Map<any, any> = new Map();

  constructor() {
    super(CubiqTS.UserImpl);
  }

  getUser(code: string): CubiqTS.UserImpl {
    return this.userCodeMap[code];
  }

  getUserById(id: string): CubiqTS.UserImpl {
    return this.myItemMap.get(id);
  }

  getUsersByClientCode(code: string): CubiqTS.UserImpl[] {
    return this.usersByClientCodeMap[code];
  }

  getItemKey(item: CubiqTS.UserImpl): string {
    return item.userId?.toString();
  }

  getItem(key: CubiqTS.Long | string): CubiqTS.UserImpl {
    let user = key ? this.myItemMap.get(CubiqTS.Long.fromValue(key).toString()) : null;

    if (!user) {
      user = key ? this.privatizationItemMap.get(CubiqTS.Long.fromValue(key).toString()) : null;
    }

    return user;
  }

  deleteItem(item: CubiqTS.UserImpl): void {
    let key: string = this.getItemKey(item);

    if (key != null) {
      this.myItemMap.delete(key);
    }
    if (item.clientCodes != null && item.clientCodes.length > 0) {
      let codes = item.clientCodes;
      for (let code of codes) {
        if (Array.isArray(this.usersByClientCodeMap[code])) {
          this.usersByClientCodeMap[code] = this.usersByClientCodeMap[code].filter(
            (user: CubiqTS.UserImpl) => {
              return !CubiqTS.Long.fromValue(user.userId).equals(
                CubiqTS.Long.fromValue(item.userId),
              );
            },
          );
        }
      }
    }
  }

  mapItem(item: CubiqTS.UserImpl): void {
    if (this.myItemMap.has(item.userId.toString())) {
      let oldItem = this.myItemMap.get(item.userId.toString());
      this.deleteItem(oldItem);
    }

    this.myItemMap.set(item.userId.toString(), item);
    this.userCodeMap[item.userCode] = item;
    if (item.userType == CubiqTS.UserType.CLIENT_TRADER) {
      this.mapClientTrader(item);
    }
  }

  mapPrivatizationItem(item: CubiqTS.UserImpl, id?: string): void {
    this.privatizationItemMap.set(id ? id : item.userId.toString(), item);
  }

  mapClientTrader(item): void {
    if (item.clientCodes != null && item.clientCodes.length > 0) {
      let codes = item.clientCodes;
      for (let code of codes) {
        if (this.usersByClientCodeMap[code] == null) {
          this.usersByClientCodeMap[code] = new Array<CubiqTS.UserImpl>();
        }
        this.usersByClientCodeMap[code].push(item);
      }
    } else if (item.clientCode != null) {
      logger.out.warn(`User.clientCodes unavailable, mapping clientCode:${item.clientCode}`);
      let code = item.clientCode;

      if (this.usersByClientCodeMap[code] == null) {
        this.usersByClientCodeMap[code] = new Array<CubiqTS.UserImpl>();
      }

      this.usersByClientCodeMap[code].push(item);
    } else {
      logger.out.error(
        `User.clientCodes or User.clientCode unavailable, not mapping User.userCode:${item.userCode}`,
      );
    }
  }
}
